import { z } from "zod";

export const skuFormSchema = z.object({
  name: z.string().max(75),
  image_url: z.union([z.string().url(), z.literal("")]).optional(),
  animation_url: z.union([z.string().url(), z.literal("")]).optional(),
  description: z.string().optional(),
  header_logo_url: z.union([z.string().url(), z.literal("")]).optional(),
  builder_io_url: z.string().optional(),
  builder_io_api_key: z.string().optional(),
  login_type: z.union([z.literal(0), z.literal(1), z.literal(2)]),
  redirect_url: z.union([z.string().url(), z.literal("")]).optional(),
  notes: z.string().optional(),
  analytics_url: z.union([z.string().url(), z.literal("")]).optional(),
  nft_chain_id: z.string().optional(),
  // @todo: separate static system values from user input forms
  nft_token_id: z.number().optional(),
  total_tags_count: z.number().optional(),
  page_type: z.union([
    z.literal("legitimate"),
    z.literal("redirect"),
    z.literal("builder_io"),
  ]),
});

export type SKUFormValues = z.infer<typeof skuFormSchema>;
